<template>
    <div v-if="type == 'intro'">
        <aw-intro 
            :currentSlide=contents.currentSlide
            v-on="$listeners"
        ></aw-intro>
    </div>
    <div v-else-if="type == 'plan'">
        <aw-plan 
            :contents=contents
            v-on="$listeners"
        ></aw-plan>
    </div>
    <div v-else-if="type == 'exercise'">
        <aw-exercise :contents=contents></aw-exercise>
    </div>
    <div v-else-if="type == 'lesson'">
        <aw-lesson 
            :contents=contents
            v-on="$listeners"
        ></aw-lesson>
    </div>
    <div v-else-if="type == 'opinion'">
        <aw-opinion :contents=contents></aw-opinion>
    </div>
    <div v-else-if="type == 'pre-test'">
        <aw-pre-test :contents=contents></aw-pre-test>
    </div>
    <div v-else-if="type == 'quiz'">
        <aw-quiz :contents=contents></aw-quiz>
    </div>
    <div v-else-if="type == 'summary'">
        <aw-summary 
            :contents=contents
            v-on="$listeners"
        ></aw-summary>
    </div>
    <div v-else-if="type == 'outro'">
        <aw-outro :currentSlide=contents.currentSlide></aw-outro>
    </div>
    <!-- <div v-else-if="type == 'supplementary'">
        <aw-supplementary :contents=contents></aw-supplementary>
    </div> -->
</template>
<script>
export default {
    props : ['contents'],
    data(){
        return{
            list : []
        }
    },
    computed:{
        type(){
            if(this.contents != null && this.contents.currentSlide != null){
                return this.contents.currentSlide.type
            }
            return null
        }
    },
    methods:{
        getList(){
        }
    },
    mounted(){
    }
}
</script>